<template>
  <div>
    <svg :id="`svg-${runid}`" height="50" width="50" viewport="0 0 50 50" :viewBox="`${svgprops.x} ${svgprops.y} ${svgprops.width} ${svgprops.height}`" preserveAspectRatio="xMinYMin meet">
      <g>
        <path vector-effect="non-scaling-stroke" :d="svgprops.path"></path>
      </g>
    </svg>
  </div>
</template>

<script>
import polyline from "@mapbox/polyline";

export default {
  name: "PolyToSVG.vue",
  props: {
    polyLine: String,
    runid: Number
  },
  data() {
    return {
      polypoints: null,
    }
  },
  computed: {
    svgprops() {
      let $vm = this;
      let path = polyline.decode($vm.polyLine);
      return $vm.poly_gm2svg(path, function (latLng) {
        return {
          lat: latLng[0],
          lng: latLng[1]
        }
      });
    },
  },
  methods: {
    latLng2point(latLng) {
      return {
        x: (latLng.lng + 180) * (256 / 360),
        y: (256 / 2) - (256 * Math.log(Math.tan((Math.PI / 4) + ((latLng.lat * Math.PI / 180) / 2))) / (2 * Math.PI))
      };
    },
    poly_gm2svg(gmPath, fx) {
      var $vm = this;
      var point,
          svgPath,
          minX = 256,
          minY = 256,
          maxX = 0,
          maxY = 0;

        svgPath = [];
        for (var p = 0; p < gmPath.length; ++p) {
          point = $vm.latLng2point(fx(gmPath[p]));
          minX = Math.min(minX, point.x);
          minY = Math.min(minY, point.y);
          maxX = Math.max(maxX, point.x);
          maxY = Math.max(maxY, point.y);
          svgPath.push([point.x, point.y].join(','));
        }

      return {
        path: 'M' + svgPath.join(' '),
        x: minX,
        y: minY,
        width: (maxX > minX) ? maxX - minX : 1,
        height: (maxY > minY) ? maxY - minY : 1
      };

    },
  },
}
</script>

<style lang="scss">
path {
    stroke: #fc9628;
    stroke-width: 1;
    fill: none;
}
</style>
